export const BACKGROUND_COLOR = {
  beige: '--orange-200',
  purple: '--purple-200',
  blue: '--blue-200',
  green: '--green-200',
};
